// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4aeedd79","977":"4f18a4c3"}[chunkId] + ".chunk.js";
};